export default "__VITE_ASSET__AJh9$zoF__"